import React from 'react';
import ContactInfoSection from './ContactInfoSection';
// Components

function ContactPageMainContainer() {
  return (
    <main role='main' className='grid w-full h-full pb-24'>
      {/* Contact Section */}
      <ContactInfoSection />
    </main>
  );
}

export default ContactPageMainContainer;
